import history from '@history';
import { useSelector } from 'react-redux';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import WdPageSimple from '@main/core/WdPageSimple';
import { ComposedHeader, FormCardLayout, LargeAvatar, TextWithLabel } from '@main/components';
import { Chip, Typography } from '@mui/material';
import { useMatchScopes } from '@main/hooks';
import { getScopes } from 'app/api/admin';
import { hasScope } from 'src/app/scopes/scopes';

const allScopesMsg = 'Este administrador cuenta con todos los permisos y accesos';

const Root = styled(WdPageSimple)(({ theme }) => ({
  '& .WdPageSimple-header': {},
  '& .WdPageSimple-content': {},
}));
// export const Profile: React.FC<ProfileProps> = () => {
export const Profile = () => {
  const {
    id,
    name,
    email,
    phone,
    company,
    avatar,
    backgroundColor,
    scopes: selfScopes,
  } = useSelector((state) => state.profile);
  const { config } = useSelector((state) => state.config);
  const { api } = config;
  const { list: userScopeList } = useMatchScopes(selfScopes, getScopes);

  return (
    <Root
      header={<ComposedHeader decorator="button" />}
      content={
        <Box
          className="flex flex-col items-center"
          sx={{
            width: '100%',
            height: '100%',
          }}
        >
          <FormCardLayout title="Perfil de Administrador">
            <FormCardLayout.HalfColum>
              <div className="flex flex-col items-center w-full h-full">
                <LargeAvatar
                  baseUri={api?.host}
                  color={backgroundColor}
                  path={avatar ? avatar.fullPathThumb || avatar.fullPath : undefined}
                  name={name}
                />
              </div>
            </FormCardLayout.HalfColum>
            <FormCardLayout.HalfColum>
              <TextWithLabel title="Nombre">{name}</TextWithLabel>
              <TextWithLabel title="Correo">{email}</TextWithLabel>
              {phone && <TextWithLabel title="Teléfono">{phone}</TextWithLabel>}
              {company && <TextWithLabel title="Compañía">{company}</TextWithLabel>}
            </FormCardLayout.HalfColum>
            <FormCardLayout.RowButton>
              {hasScope(selfScopes, 'Admins', 'update') && (
                <Button
                  variant="contained"
                  color="info"
                  onClick={() => history.push(`/myself/update/${id}`)}
                >
                  Editar información
                </Button>
              )}
              {hasScope(selfScopes, 'Admins', 'update') && (
                <Button
                  variant="contained"
                  color="info"
                  onClick={() => history.push(`/myself/recovery/${id}`)}
                >
                  Cambiar contraseña
                </Button>
              )}
              {hasScope(selfScopes, 'Admins', 'show') && (
                <Button variant="contained" color="primary" onClick={() => history.push('/admin')}>
                  Ver más administradores
                </Button>
              )}
            </FormCardLayout.RowButton>
          </FormCardLayout>
          <FormCardLayout title="Permisos y accesos">
            <FormCardLayout.FullColum>
              {selfScopes.includes('*') ? (
                <Chip label={allScopesMsg} />
              ) : (
                userScopeList.map((scopeGroup) => (
                  <div key={scopeGroup.label} className="mb-24">
                    <Typography className="text-lg font-semibold leading-tight mb-8">
                      {scopeGroup.label}
                    </Typography>
                    <Typography className="text-base font-light leading-tight" color="light">
                      {scopeGroup.description}
                    </Typography>
                    <div className="mt-12">
                      {scopeGroup.scopes.map((scope) => {
                        return <Chip key={scope.key} label={scope.value} className="mr-4 mb-8" />;
                      })}
                    </div>
                  </div>
                ))
              )}
            </FormCardLayout.FullColum>
          </FormCardLayout>
        </Box>
      }
    />
  );
};
